import apiClient from './api';

class AuthService {
  // Login
  async login(email, password) {
    try {
      const response = await apiClient.post('/Auth/login', {
        email,
        password,
      });
      
      const { token, userId, email: userEmail, name, organizationId, organizationName } = response.data;
      
      // Store token and user data
      localStorage.setItem('authToken', token);
      localStorage.setItem('userData', JSON.stringify({
        userId,
        email: userEmail,
        name,
        organizationId,
        organizationName,
      }));
      
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Login failed. Please check your credentials.';
    }
  }

  // Register
  async register(userData) {
    try {
      // Map frontend field names to API field names
      const payload = {
        organizationName: userData.organizationName,
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        phoneNo: userData.phoneNumber, // Note: API uses 'phoneNo' not 'phoneNumber'
        password: userData.password,
      };
      
      const response = await apiClient.post('/Auth/register', payload);
      
      const { token, userId, email, name, organizationId, organizationName } = response.data;
      
      // Store token and user data (auto-login after registration)
      localStorage.setItem('authToken', token);
      localStorage.setItem('userData', JSON.stringify({
        userId,
        email,
        name,
        organizationId,
        organizationName,
      }));
      
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.title || 'Registration failed. Please try again.';
    }
  }

  // Forgot Password
  async forgotPassword(email) {
    try {
      const response = await apiClient.post('/Auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to send reset link. Please try again.';
    }
  }

  // Logout
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
  }

  // Get current user data
  getCurrentUser() {
    const userData = localStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  }

  // Check if user is authenticated
  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  }
}

export default new AuthService();